import { render, staticRenderFns } from "./PushNotificationPage.vue?vue&type=template&id=2283dcf8&scoped=true&"
import script from "./PushNotificationPage.vue?vue&type=script&lang=js&"
export * from "./PushNotificationPage.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationPage.vue?vue&type=style&index=0&id=2283dcf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283dcf8",
  null
  
)

export default component.exports